import { ICONS } from "../generated/icons.js";

/**
 * Le icone dell'app desktop, ricolorabili.
 *
 * L'SVG e' in linea e usa `currentColor`, non un `<img src>`: qui il colore
 * **dice lo stato** — verde, giallo, rosso — e un'immagine che non si puo'
 * ricolorare sarebbe un'icona che mente. E' la stessa ragione per cui
 * `Icon.qml` le ridipinge con MultiEffect invece di caricarle e basta.
 *
 * Sono gli STESSI file dell'app desktop, generati: ridisegnarne una a mano, o
 * pescarla da un altro set, darebbe due interfacce che si somigliano.
 */
export function Icon({
  name,
  size = 16,
  className,
  style,
}: {
  name: string;
  size?: number;
  className?: string;
  style?: React.CSSProperties;
}) {
  const body = ICONS[name];
  if (!body) return null;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      {...(style ? { style } : {})}
      aria-hidden="true"
      dangerouslySetInnerHTML={{ __html: body }}
    />
  );
}
